import type { FlatGraphNode } from '@/sections/insights/queryBuilder/types/FlatGraph';
import type { QueryFilter } from '@/types';

interface NodeLogicalToggleButtonProps {
  node: FlatGraphNode;
  filters: QueryFilter[];
  editable: boolean;
  currentOperator: 'AND' | 'OR';
  onUpdateFilters?: (nodeId: string, filters: QueryFilter[]) => void;
  handleToggleOperator: (
    currentFilters: QueryFilter[],
    currentOperator: 'AND' | 'OR'
  ) => QueryFilter[];
}

const NodeLogicalToggleButton = ({
  node,
  filters,
  editable,
  currentOperator,
  onUpdateFilters,
  handleToggleOperator,
}: NodeLogicalToggleButtonProps) => {
  return (
    <button
      onClick={() => {
        if (!onUpdateFilters) return;
        const updatedFilters = handleToggleOperator(filters, currentOperator);
        onUpdateFilters(node.id, updatedFilters);
      }}
      disabled={!editable || !onUpdateFilters}
      className={`rounded border px-3 py-1 text-xs font-medium transition-colors ${
        editable && onUpdateFilters
          ? 'border-chariot-stroke bg-chariot-background-secondary text-chariot-text-primary hover:bg-chariot-background-tertiary'
          : 'border-chariot-stroke bg-chariot-background-primary text-chariot-text-secondary cursor-not-allowed opacity-90'
      }`}
      data-testid={`toggle-operator-${node.id}`}
      aria-label={`Toggle between AND and OR operators`}
    >
      {currentOperator}
    </button>
  );
};

export default NodeLogicalToggleButton;
